import XrCardAv from "../../../components/XrCardAv.tsx";
import XrTextAv from '../../../components/XrTextAv.tsx';
import XrInputAv from '../../../components/XrInputAv.tsx';
import XrButtonAv from '../../../components/XrButtonAv.tsx';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { toast } from "react-toastify";

const FormContact = (props) => {
  const [roleOptions, setRoleOptions] = useState([]);
  const authorizedUser = useSelector((state) => state.authentication.authorizedUser);
  const [inputDisabled, setInputDisabled] = useState(false);
  console.log('this is authorized user: ', authorizedUser);
  useEffect(() => {
    const newOptions = [];
    props.roles.forEach(item => {
      if (item.id) {
        newOptions.push({
          value: item,
          label: item.role_name
        });
      }
    });
    setRoleOptions(newOptions);
  }, [props.roles]);

  const onChangeContactSync = (e) => {
    setInputDisabled(e.target.checked);
    if (e.target.checked) {
      props.setForm({
        ...props.form,
        issuer_name: authorizedUser.name,
        issuer_phone: authorizedUser.phone_number,
        id_role: authorizedUser.id_role
      });
      props.setSelectedRole({
        label: authorizedUser.role_detail.role_name,
        value: authorizedUser.role_detail
      })
      return;
    }
    props.setForm({
      ...props.form,
      issuer_name: '',
      issuer_phone: '',
      id_role: null
    });
    props.setSelectedRole(null);
  }

  const actionChangeInventory = () => {
    props.setCurrentStep('03-peminjaman-inventaris');
  }

  const actionConfirmation = () => {
    const newErrors = {...props.errors};
    let hasError = false;
    if (!props.form.issuer_name) {
      hasError = true;
      newErrors.issuer_name = [ 'Nama peminjam wajib diisi.' ];
    } else {
      newErrors.issuer_name = [];
    }
    if (!props.form.issuer_phone) {
      hasError = true;
      newErrors.issuer_name = [ 'Nomor telepon peminjam wajib diisi.' ];
    } else {
      newErrors.issuer_name = [];
    }
    if (!props.form.id_role) {
      hasError = true;
      newErrors.issuer_name = [ 'Organisasi peminjam wajib diisi.' ];
    } else {
      newErrors.issuer_name = [];
    }

    props.setErrors(newErrors);
    if (hasError) {
      toast.error('Tidak dapat melanjutkan ke tahap berikutnya, mohon lengkapi formulir yang disediakan.');
      return;
    };

    props.setCurrentStep('05-konfirmasi');
  }
  
  const onChangeRole = (e) => {
    props.setSelectedRole(e);
    props.setErrors({ ...props.errors, role_id: [] })
    props.setForm({ ...props.form, role_id: e.value.id })
  }

  const onChangeIsuerName = (e) => {
    props.setErrors({ ...props.errors, issuer_name: [] })
    props.setForm({ ...props.form, issuer_name: e.target.value })
  }

  const onChangeIssuerPhoneNumber = (e) => {
    props.setErrors({ ...props.errors, issuer_phone: [] })
    props.setForm({ ...props.form, issuer_phone: e.target.value })
  }
    
  return (
    <FormContactWrapper>
      <XrCardAv>
        <div className="card--title">
          <div className="card--title requestBooking__toolbar">
            <div>
              <XrTextAv tag='h2' variant='title'>
                Identitas Pemohon
              </XrTextAv>
              <XrTextAv tag='p' variant='description'>
                Informasi orang yang mengajukan permohonan.
              </XrTextAv>
            </div>
            <XrButtonAv
              noBlock
              size='large'
              caption={`Ubah Inventaris`}
              disabled={props.isLoading}
              isLoading={props.isLoading}
              onClick={actionChangeInventory}
            />
          </div>
        </div>
        <div className="card--body">
          <XrInputAv
            type='text`'
            required={true}
            disabled={true}
            label='Nama Pemohon'
            value={authorizedUser.name}
          />
          <XrInputAv
            type='text`'
            required={true}
            disabled={true}
            label='Organisasi'
            value={authorizedUser.role_detail.role_name}
          />
          <XrInputAv
            type='text`'
            required={true}
            disabled={true}
            label='Nomor Telepon Pemohon'
            value={authorizedUser.phone_number}
          />
        </div>
      </XrCardAv>
      <XrCardAv>
        <div className="card--title">
          <XrTextAv tag='h2' variant='title'>
            Identitas Peminjam
          </XrTextAv>
          <XrTextAv tag='p' variant='description'>
            Identitas orang yang akan mengambil kunci ruangan dan inventaris. Apabila sama, silahkan centang isian dibawah.
          </XrTextAv>
        </div>
        <div className="card--body">
          <div style={{ marginBottom: '10px' }}>
            <input type='checkbox' id='sync-data' onChange={onChangeContactSync} />
            <label htmlFor='sync-data' style={{ fontSize: '14px' }}>Data pemohon dan peminjam sama</label>
          </div>
          
          <XrInputAv
            type='text`'
            required={true}
            disabled={props.isLoading || inputDisabled}
            isLoading={props.isLoading}
            label='Nama Peminjam'
            onChange={onChangeIsuerName}
            value={props.form.issuer_name}
          />
          <XrInputAv
            type='text`'
            required={true}
            isLoading={props.isLoading}
            label='Nomor Telepon Peminjam'
            value={props.form.issuer_phone}
            onChange={onChangeIssuerPhoneNumber}
            disabled={props.isLoading || inputDisabled}
          />
          <XrInputAv
            label='Organisasi Peminjam'
            required={true}
            disabled={props.isLoading || inputDisabled}
            isLoading={props.isLoading}
            placeholder='Pilih organisasi peminjam'
            selectProps={{
              value: props.selectedRole,
              options: roleOptions,
              onChange: onChangeRole
            }}
            errorMessage={props.errors.role_id}
          />
        </div>
      </XrCardAv>

      <XrButtonAv
        noBlock
        size='large'
        color='primary'
        caption={`Konfirmasi Peminjaman`}
        disabled={props.isLoading}
        isLoading={props.isLoading}
        onClick={actionConfirmation}
      />
    </FormContactWrapper>
  );
}

const FormContactWrapper = styled.div`
`;

export default FormContact;